module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-15GENNAIO-25-small-9cc2dbb2badcfe96d45680f7571ed1b1.png";